module.exports = __webpack_public_path__ + "img/parking_0.2ff33049.jpg";